import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  Input,
} from '@angular/core';
import { LearningResourceViewModel } from '@app/inputs/models/learning-resource.view-model';
import { SearchFlagsService } from '@app/search/services';
import { SearchTrackerService } from '@app/search/services/search-tracker.service';
import { NUM_RESULTS_PER_PAGE } from '@app/shared/search.token';
import { TrackerService } from '@dg/shared-services';

@Component({
  selector: 'dgx-search-results',
  templateUrl: './search-results.component.html',
  styleUrls: ['./search-results.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
// contentOpened
export class SearchResultsComponent {
  @Input() public results: LearningResourceViewModel[];
  @Input() public isLoading: boolean;
  @Input() public totalContentResults: number;
  @Input() public searchTerm: string;
  @Input() public pageNum: number = 1;

  @Input() public trackingLocation: string = 'Search';
  @Input() public onClickTrackingEvent: string = 'contentClicked';

  constructor(
    private searchTrackerService: SearchTrackerService,
    private searchFlagsService: SearchFlagsService,
    private trackerService: TrackerService,
    @Inject(NUM_RESULTS_PER_PAGE) public readonly numResultsPerPage: number
  ) {}

  public get showSearchLayoutRedesign(): boolean {
    return this.searchFlagsService.showSearchLayoutRedesign;
  }

  public getSearchItemTrackingConfig(index: number) {
    const resultPosition =
      this.pageNum * this.numResultsPerPage -
      (this.numResultsPerPage - index) +
      1;
    return {
      location: this.trackingLocation,
      searchTerm: this.searchTerm,
      currentPage: this.pageNum,
      resultPosition,
      totalContentResults: this.totalContentResults,
    };
  }

  public onInputSelected(resource: LearningResourceViewModel, index: number) {
    const resultPosition =
      this.pageNum * this.numResultsPerPage -
      (this.numResultsPerPage - index) +
      1;
    this.searchTrackerService[this.onClickTrackingEvent](
      resource,
      this.getSearchItemTrackingConfig(index)
    );
  }

  public trackByFn(index: number, item: LearningResourceViewModel): string {
    return item.trackingKey;
  }

  public onIntersectionOfResult(
    item: LearningResourceViewModel,
    itemIndex: number
  ): void {
    this.trackerService.trackEventData({
      action: 'Content Impressed',
      properties: {
        location: this.trackingLocation, // Maps to ActionLocation in Amplitude
        inputType: item.reference?.resourceType || item.resourceType, // Maps to ContentType in Amplitude
        contentId: item.reference?.resourceId || item.resourceId,
        title: item.reference?.title || item.title,
        providerId: item.reference?.providerId,
        providerName: item.reference?.providerName,
        position: itemIndex,
        dateCreated: item.reference?.dateCreated,
      },
    });
  }
}
